import React from "react";

export const Logo = ({ className = "", height = 28 }) => {
  return (
    <svg
      data-testid="brand-logo"
      className={className}
      height={height}
      viewBox="0 0 320 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="pflege-box-gratis Logo"
    >
      <defs>
        <linearGradient id="lg-green" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#2E8B5A" />
          <stop offset="100%" stopColor="#5FB983" />
        </linearGradient>
      </defs>

      {/* Box icon with medical cross */}
      <g transform="translate(2 8)">
        <rect
          x="2"
          y="2"
          width="36"
          height="36"
          rx="9"
          stroke="url(#lg-green)"
          strokeWidth="2"
          fill="rgba(63,166,109,0.10)"
        />
        <rect x="17" y="9" width="6" height="22" rx="2" fill="url(#lg-green)" />
        <rect x="9" y="17" width="22" height="6" rx="2" fill="url(#lg-green)" />
      </g>

      {/* Wordmark */}
      <g transform="translate(54 0)" fontFamily="Outfit, sans-serif">
        <text
          x="0"
          y="36"
          fontSize="26"
          fontWeight="600"
          fill="#1A1A1F"
          letterSpacing="-0.5"
        >
          pflege
        </text>
        <text
          x="98"
          y="36"
          fontSize="26"
          fontWeight="500"
          fill="#5A5F66"
          letterSpacing="-0.5"
        >
          ·
        </text>
        <text
          x="110"
          y="36"
          fontSize="26"
          fontWeight="600"
          fill="url(#lg-green)"
          letterSpacing="-0.5"
        >
          box
        </text>
        <text
          x="160"
          y="36"
          fontSize="26"
          fontWeight="500"
          fill="#5A5F66"
          letterSpacing="-0.5"
        >
          ·
        </text>
        <text
          x="172"
          y="36"
          fontSize="26"
          fontWeight="500"
          fill="#1A1A1F"
          letterSpacing="-0.5"
        >
          gratis
        </text>
      </g>
    </svg>
  );
};

export default Logo;
